<template>
  <div class="layout-container">
    <div class="main">
        <!-- 二级路由出口 -->
        <router-view/>
    </div>

    <!-- <van-tabbar id="vanTabber" safe-area-inset-bottom route> -->
      <!-- <van-tabbar-item icon="cluster-o" replace to="/layout/channel">Channel</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="wap-home-o" replace to="/layout/home">
        <span>Store</span>
        <template #icon="props">
          <img :src="props.active ? actveStoreImg : storeImg" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="location-o" replace to="/layout/storeMap">Map</van-tabbar-item> -->
      <!-- <van-tabbar-item replace to="/layout/event">
        <span>Event</span>
        <template #icon="props">
          <img :src="props.active ? actveEventImg : eventImg" />
        </template>
      </van-tabbar-item> -->
      <!-- <van-tabbar-item icon="orders-o" replace to="/layout/plan">Plan</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="user-circle-o" replace to="/layout/user">My</van-tabbar-item> -->
    <!-- </van-tabbar> -->
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
  .main {
    margin-bottom: 50px;
  }
</style>
